import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//------------------------------------------------------------------------------
//               Отправить запрос на опубликование сигнала
//------------------------------------------------------------------------------
export const approveSignal = async ({ id }) => {
  try{
    const url = `${backendUrl}/api/signals/moderation/${id}/`;
    const options = {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
    };
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при опубликовании сигнала: HTTP error! Status: ${ response.status }`);
    }
    return await response.json();
  } catch(error){
    console.error('Программная ошибка публикования сигнала:', error);
    throw error;
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx